import { Link } from 'react-router-dom';
import { categories } from '@/mocks/posts';

interface CategoryTabsProps {
  activeSlug: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-8 flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-500'
          }`}
        >
          {cat.name}
          <span className={`ml-1.5 text-xs ${activeSlug === cat.slug ? 'text-white/70' : 'text-foreground-400'}`}>
            {cat.postCount}
          </span>
        </Link>
      ))}
    </div>
  );
}